module.exports = __webpack_public_path__ + "static/media/ic_dialog_warning.8fb3ad43.svg";